// extracted by mini-css-extract-plugin
export default {"container":"Title_container__0Sk2P","link":"Title_link__i+DBy"};